import './range.datepicker.scss'
import 'moment/locale/ru'
import moment from 'moment'
import 'imports-loader?define=>false!daterangepicker' // eslint-disable-line import/no-webpack-loader-syntax
import defaultRanges from './default.ranges'
import _ from 'lodash'
import $ from 'jquery'

export default class {
  constructor(input) {
    this.$input = $(input)
    this.initial = this.$input.data('initial')
  }

  setup() {
    this.$input.daterangepicker(this._datepickerArgument())
    this._addEventListeners()

    if (this.initial) this._setInputValue(this.initial)
  }

  subscribeOnValueChange(callback: (value: String) => void) {
    this.$input.on('apply.daterangepicker', (ev, picker) => {
      callback(this._getValueFromPicker(picker))
    })
  }

  _addEventListeners() {
    let form = this.$input.closest('.JS-RangeDatepicker-form')[0]

    this.$input.on('apply.daterangepicker', (ev, picker) => {
      this._setInputValue(this._getValueFromPicker(picker))
    })

    if (form) {
      this.$input.on('apply.daterangepicker', (ev, picker) => {
        if (picker.chosenLabelAlias && picker.chosenLabelAlias.length > 0) {
          window.location =
            form.action + '?' + form.elements[0].name + '=' + picker.chosenLabelAlias
        } else {
          form.submit()
        }
      })
    }
  }

  _datepickerArgument() {
    let ranges = _.cloneDeep(defaultRanges)

    if (this.$input.data('origin')) {
      ranges['За все время'] = [new Date(this.$input.data('origin')), moment(), 'all']
    }

    const datepickerArgument = {
      autoUpdateInput: false,
      ranges: ranges,
      opens: this.$input.data('align') || 'left',
      locale: {
        format: 'DD.MM.YYYY',
        separator: this.$input.data('separator') || '-',
        applyLabel: 'Применить',
        cancelLabel: 'Очистить',
        language: 'ru',
        monthNames: moment.months(),
        customRangeLabel: 'Свой интервал'
      }
    }

    if (this.initial) {
      const [start, end] = this.initial.split(' - ')
      datepickerArgument.startDate = start
      datepickerArgument.endDate = end
    }

    return datepickerArgument
  }

  _setInputValue(value: String) {
    this.$input.val(value)
  }

  _getValueFromPicker(picker) {
    const start = picker.startDate.format('DD.MM.YYYY')
    const end = picker.endDate.format('DD.MM.YYYY')

    return `${start} - ${end}`
  }
}
